import type * as Types from '../types/graphql';

import type { DocumentNode } from 'graphql';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type AllSearchResultsFilterablesQueryVariables = Types.Exact<{
  locale?: Types.InputMaybe<Types.Locale>;
}>;


export type AllSearchResultsFilterablesQuery = { __typename?: 'Query', allQualifications?: Array<{ __typename?: 'Qualification', id: string, text?: string | null }> | null };

export const AllSearchResultsFilterablesDocument = /*#__PURE__*/ {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"allSearchResultsFilterables"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Locale"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allQualifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class AllSearchResultsFilterablesGQL extends Apollo.Query<AllSearchResultsFilterablesQuery, AllSearchResultsFilterablesQueryVariables> {
    document = AllSearchResultsFilterablesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }